import { render, staticRenderFns } from "./ApuracaoFornecedorArquivo.vue?vue&type=template&id=31aa9ef8&scoped=true"
import script from "./ApuracaoFornecedorArquivo.vue?vue&type=script&lang=js"
export * from "./ApuracaoFornecedorArquivo.vue?vue&type=script&lang=js"
import style0 from "./ApuracaoFornecedorArquivo.vue?vue&type=style&index=0&id=31aa9ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa9ef8",
  null
  
)

export default component.exports